import $ from 'jquery/src/jquery';

export default () => {
    const nodeSelectors = {
        container: '[js-site-header="container"]',
    }

    function init() {
        initHeader()
    }

    function initHeader() {
    }

    return Object.freeze({
        init,
    })
}